"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCompanyProfileBoxInfo = useCompanyProfileBoxInfo;
const react_1 = __importDefault(require("react"));
const auth_context_1 = require("@src/context/auth-context");
const Api = __importStar(require("@src/api"));
const account_context_1 = require("@src/context/account-context");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
function useCompanyProfileBoxInfo(company) {
    var _a, _b;
    const [subscribersCount, setSubscribersCount] = react_1.default.useState((_a = company === null || company === void 0 ? void 0 : company.subscribers) === null || _a === void 0 ? void 0 : _a.length);
    const [isSubscriptionLoading, setIsSubscriptionLoading] = react_1.default.useState(false);
    const account = (0, account_context_1.useAccount)();
    const { checkAuthentication } = (0, auth_context_1.useAuthContextValue)();
    const isAccountSubscribed = (_b = company === null || company === void 0 ? void 0 : company.subscribers) === null || _b === void 0 ? void 0 : _b.find(({ account_id }) => account_id === (account === null || account === void 0 ? void 0 : account.id));
    const SSRFetchClient = (0, useSSRFetch_1.useSSRFetchClient)();
    react_1.default.useEffect(() => {
        var _a, _b;
        if (((_a = company === null || company === void 0 ? void 0 : company.subscribers) === null || _a === void 0 ? void 0 : _a.length) !== subscribersCount) {
            setSubscribersCount((_b = company === null || company === void 0 ? void 0 : company.subscribers) === null || _b === void 0 ? void 0 : _b.length);
        }
    }, [company]);
    const toggleSubscription = react_1.default.useCallback(async () => {
        try {
            setIsSubscriptionLoading(true);
            await checkAuthentication();
            SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.account.key);
            await Api.Company.toggleCompanySubscription(company.id);
            setSubscribersCount(isAccountSubscribed ? subscribersCount - 1 : subscribersCount + 1);
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setIsSubscriptionLoading(false);
        }
    }, [company, isAccountSubscribed]);
    return { isAccountSubscribed, subscribersCount, toggleSubscription, isSubscriptionLoading };
}
